import { render, staticRenderFns } from "./mykaoshi.vue?vue&type=template&id=3cf6e34c&scoped=true"
import script from "./mykaoshi.vue?vue&type=script&lang=js"
export * from "./mykaoshi.vue?vue&type=script&lang=js"
import style0 from "./mykaoshi.vue?vue&type=style&index=0&id=3cf6e34c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cf6e34c",
  null
  
)

export default component.exports